import { atom } from "jotai"
import { GraphValidationData } from "@features/builder/GraphValidation/GraphValidationDialog"

export const graphValidationDataAtom = atom<GraphValidationData>()
